const InfoIcon = () => (
	<div style={{ width: 115, height: 115 }}>
		<svg
			width='100%'
			height='100%'
			viewBox='0 0 133 133'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g id='info-group' fill='none' stroke='none'>
				<circle
					id='circle'
					cx='66.5'
					cy='66.5'
					r='54.5'
					fill='#3498db'
				/>
				<text
					id='i-text'
					x='66.5'
					y='90'
					textAnchor='middle'
					fontSize='64'
					fontWeight='bold'
					fill='#ffffff'
					opacity='0'
				>
					i
				</text>
			</g>
		</svg>

		<style jsx>{`
			#info-group {
				transform-origin: center;
				animation: pulse 0.4s ease-in-out 1s both;
			}

			#circle {
				transform: scale(0);
				transform-origin: center;
				animation: pop-in 0.3s ease-out forwards;
			}

			#i-text {
				animation: fade-in 0.4s ease-out forwards;
				animation-delay: 0.45s;
			}

			@keyframes pop-in {
				0% {
					transform: scale(0);
				}
				100% {
					transform: scale(1);
				}
			}

			@keyframes fade-in {
				0% {
					opacity: 0;
					transform: scale(0.8);
				}
				100% {
					opacity: 1;
					transform: scale(1);
				}
			}

			@keyframes pulse {
				0% {
					transform: scale(1);
				}
				50% {
					transform: scale(1.08);
				}
				100% {
					transform: scale(1);
				}
			}
		`}</style>
	</div>
);

export default InfoIcon;
